// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__32x-A","topBottomGutter":"Layout_topBottomGutter__2ngqE"};